import Vue from "vue";
import utilsMixin from '../mixins/UtilitiesMixin.js'

Vue.component("proposed-modification-related-notifications", {
    props: ["id",
        "language",
        "filters"
    ],
    mixins: [utilsMixin],
    data() {
        return {
            isFetching: false,
            data: [],

        };
    },
    methods: {
        getAsyncData: function () {

            console.log(this.filters);
            this.isFetching = true;

            this.$services.proposedModificationNotifications.getRelatedNotifications({
                language: this.language,
                id: this.id,
                types: this.filters.types,
                documentSymbol: this.filters.documentSymbol,
                parties: this.filters.parties,
                sortBy: this.filters.sortBy,
                sortDirection: this.filters.sortDirection,
                dateFrom: this.filters.dateFrom,
                dateTo: this.filters.dateTo
            })
                .then((data) => {
                    this.data = []
                    if (data.items) {
                        data.items.forEach((item) => this.data.push(item))
                    }
                    this.isFetching = false;
                });
        },
        //openDocs: function (documentSymbol) {
        //    const raw = window.letDocumentRedirectUrl;
        //    if (raw != null || raw != undefined) {
        //        let replacer = encodeURIComponent('"' + documentSymbol + '"') + '+OR+' + encodeURIComponent('"' + documentSymbol + '/*"');
        //        let upperCaseLanguage = 'ENGLISH';
        //        switch (window.currentLanguage) {
        //            case 1:
        //            default:
        //                upperCaseLanguage = 'ENGLISH';
        //                break;
        //            case 2:
        //                upperCaseLanguage = 'FRENCH';
        //                break;
        //            case 3:
        //                upperCaseLanguage = 'SPANISH';
        //                break;
        //        }


        //        let url = raw.replace('{0}', replacer);
        //        url = url.replace('{1}', upperCaseLanguage);

        //        let final = this.removeDuplicateConnector(url);

        //        console.log(final);

        //        window.open(final, '_blank');
        //    }
        //},
    },
    created() {

        this.getAsyncData();

    },
    template: `
            <table class="table is-not-striped relatedNotifications">
             <colgroup>
               <col span="1" style="width: 200px;">
                <col span="1" style="width: 150px;">
               <col span="1" style="width: 120px;">
               <col span="1" style="width: 120px;">
            </colgroup>

                <tbody>
                    <tr v-for="item in data">
                        <td class="has-text-centered" >{{ item.notificationFormatName }}</td>
                        <td  class="has-text-centered is-align-content-center">
                            <b-field grouped group-multiline>
                                <div class="control">
                                   <a href="#" v-on:click="openDocs(item.documentSymbol)" target="_blank">  <b-tag type="is-success"
                                           attached v-on:click="openDocs(item.documentSymbol)"
                                           close-icon="search"
                                           aria-close-label="Open Document"
                                           closable v-on:close="openDocs(item.documentSymbol)">
                                        {{ item.documentSymbol }}
                                    </b-tag>
                                     </a>
                                </div>
                            </b-field>
                        </td>
                        <td  class="has-text-centered" >{{ item.partyName }}</td>
                        <td class="has-text-centered" >{{ item.submissionDate | dateFilter }}</td>
                    </tr>
                    <tr v-if="isFetching">
                        <td><b-skeleton animated></b-skeleton></td>
                        <td><b-skeleton animated></b-skeleton></td>
                        <td><b-skeleton animated></b-skeleton></td>
                        <td><b-skeleton animated></b-skeleton></td>
                    </tr>
                </tbody>
            </table>
           
	`
});